import { Sketch as Sketch1681039200 } from "../sketches/1681039200/1681039200";
import { Sketch as Sketch1683455940 } from "../sketches/1683455940/1683455940";
import { Sketch as Sketch1686478500 } from "../sketches/1686478500/1686478500";
import { Sketch as Sketch1687083300 } from "../sketches/1687083300/1687083300";
import { Sketch as Sketch1687688160 } from "../sketches/1687688160/1687688160";
import { Sketch as Sketch1688898153 } from "../sketches/1688898153/1688898153";
import { Sketch as Sketch1690108450 } from "../sketches/1690108450/1690108450";
import { Sketch as Sketch1696766018 } from "../sketches/1696766018/1696766018";
import { Sketch as Sketch1697371287 } from "../sketches/1697371287/1697371287";
import { Sketch as Sketch1698495397 } from "../sketches/1698495397/1698495397";
import { Sketch as Sketch1700397800 } from "../sketches/1700397800/1700397800";
import { Sketch as Sketch1701003087 } from "../sketches/1701003087/1701003087";


export const sketchData = [
  {
    id: 1681039200,
    name: "1681039200",
    description: "rabbit follow cursor",
    sketch: Sketch1681039200,
  },
  {
    id: 1683455940,
    name: "1683455940",
    description: "drifting green ellipses",
    sketch: Sketch1683455940,
  },
  {
    id: 1686478500,
    name: "1686478500",
    description: "unown",
    sketch: Sketch1686478500,
  },
  {
    id: 1687083300,
    name: "1687083300",
    description: "unown",
    sketch: Sketch1687083300,
  },
  {
    id: 1687688160,
    name: "1687688160",
    description: "unown",
    sketch: Sketch1687688160,
  },
  {
    id: 1688898153,
    name: "1688898153",
    description: "unown",
    sketch: Sketch1688898153,
  },
  {
    id: 1690108450,
    name: "1690108450",
    description: "unown",
    sketch: Sketch1690108450,
  },
  {
    id: 1696766018,
    name: "1696766018",
    description: "unown",
    sketch: Sketch1696766018,
  },
  {
    id: 1697371287,
    name: "1697371287",
    description: "unown",
    sketch: Sketch1697371287,
  },
  {
    id: 1698495397,
    name: "1698495397",
    description: "unown",
    sketch: Sketch1698495397,
  },
  {
    id: 1700397800,
    name: "1700397800",
    description: "unown",
    sketch: Sketch1700397800,
  },
  {
    id: 1701003087,
    name: "1701003087",
    description: "unown",
    sketch: Sketch1701003087,
  },
]; 